let logoutTimer = null;
let warningTimer = null;
let warningCountdownInterval = null;
let resetTimerHandler = null;
let logoutTime = null;
let warningDisplayed = false;
let refreshInFlight = false;

const WARNING_ELEMENT_ID = 'inactivity-warning-banner';

function getTokenExpiry() {
  return parseInt(localStorage.getItem('token_expiry') || '0', 10);
}

function removeWarningBanner() {
  if (warningCountdownInterval) {
    clearInterval(warningCountdownInterval);
    warningCountdownInterval = null;
  }

  const banner = document.getElementById(WARNING_ELEMENT_ID);
  if (banner?.parentNode) {
    banner.parentNode.removeChild(banner);
  }
}

function createWarningBanner(secondsLeft, onStaySignedIn) {
  removeWarningBanner();

  const banner = document.createElement('div');
  banner.id = WARNING_ELEMENT_ID;
  banner.style.position = 'fixed';
  banner.style.bottom = '16px';
  banner.style.right = '16px';
  banner.style.zIndex = '9999';
  banner.style.background = '#1f2937';
  banner.style.color = '#ffffff';
  banner.style.padding = '12px 16px';
  banner.style.borderRadius = '8px';
  banner.style.boxShadow = '0 10px 30px rgba(0,0,0,0.3)';
  banner.style.display = 'flex';
  banner.style.alignItems = 'center';
  banner.style.gap = '12px';

  const message = document.createElement('div');
  message.textContent = `You have been inactive. You will be logged out in ${secondsLeft} seconds.`;

  const button = document.createElement('button');
  button.textContent = 'Stay signed in';
  button.style.background = '#10b981';
  button.style.color = '#fff';
  button.style.border = 'none';
  button.style.borderRadius = '6px';
  button.style.padding = '8px 12px';
  button.style.cursor = 'pointer';

  button.addEventListener('click', onStaySignedIn);

  banner.appendChild(message);
  banner.appendChild(button);
  document.body.appendChild(banner);

  warningCountdownInterval = setInterval(() => {
    const remainingSeconds = Math.max(Math.ceil((logoutTime - Date.now()) / 1000), 0);
    message.textContent = `You have been inactive. You will be logged out in ${remainingSeconds} seconds.`;
  }, 1000);
}

export function startInactivityTimer(
  logoutCallback,
  timeoutMinutes = 15,
  warningSeconds = 30,
  { tokenRefreshFn = null, refreshThresholdSeconds = 60 } = {}
) {
  stopInactivityTimer();

  const inactivityTimeout = timeoutMinutes * 60 * 1000;

  const maybeRefreshToken = async () => {
    if (!tokenRefreshFn || refreshInFlight) return;

    const expiry = getTokenExpiry();
    if (!expiry) return;

    const secondsToExpiry = (expiry - Date.now()) / 1000;
    if (secondsToExpiry <= refreshThresholdSeconds) {
      refreshInFlight = true;
      try {
        await tokenRefreshFn();
      } finally {
        refreshInFlight = false;
      }
    }
  };

  const showWarningAndLogout = () => {
    warningDisplayed = true;

    const timeRemaining = Math.max(logoutTime - Date.now(), 0);
    const handleStaySignedIn = () => {
      warningDisplayed = false;
      removeWarningBanner();
      scheduleTimers();
      maybeRefreshToken();
    };

    createWarningBanner(Math.max(Math.ceil(timeRemaining / 1000), 0), handleStaySignedIn);
    warningTimer = setTimeout(() => {
      removeWarningBanner();
      logoutCallback();
    }, timeRemaining);
  };

  const scheduleTimers = () => {
    clearTimeout(logoutTimer);
    clearTimeout(warningTimer);

    const now = Date.now();
    logoutTime = now + inactivityTimeout;

    const warningTime = logoutTime - warningSeconds * 1000;
    const timeToWarning = warningTime - now;

    if (timeToWarning <= 0) {
      if (!warningDisplayed) {
        showWarningAndLogout();
      }
    } else {
      warningDisplayed = false;
      removeWarningBanner();
      logoutTimer = setTimeout(showWarningAndLogout, timeToWarning);
    }
  };

  const handleActivity = () => {
    warningDisplayed = false;
    removeWarningBanner();
    scheduleTimers();
    maybeRefreshToken();
  };

  resetTimerHandler = handleActivity;

  ['click', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach((event) => {
    document.addEventListener(event, resetTimerHandler);
  });

  scheduleTimers();
  maybeRefreshToken();
}

export function stopInactivityTimer() {
  clearTimeout(logoutTimer);
  clearTimeout(warningTimer);
  if (resetTimerHandler) {
    ['click', 'mousemove', 'keypress', 'scroll', 'touchstart'].forEach((event) => {
      document.removeEventListener(event, resetTimerHandler);
    });
  }
  removeWarningBanner();
  warningDisplayed = false;
  refreshInFlight = false;
}
